import {inject, Injectable} from "@angular/core";
import {LorenAdminChannel} from "../../interfaces/loren-admin-channel.interface";
import {LorenBaseCrudService} from "../../../../../shared/services/loren-base-crud-service/loren-base-crud.service";
import {
    LorenAdminChannelsEndpointsService
} from "../loren-admin-channels-endpoints-service/loren-admin-channels-endpoints.service";
import {BehaviorSubject, Observable} from "rxjs";
import {
    LorenSession
} from "../../../../../shared/services/loren-authentication-service/constants/loren-user-session.constants";
import {map} from "rxjs/operators";
import {GenericItems} from "../../../../../shared/interfaces/generic-items.interface";

@Injectable({
    providedIn: "root",
})
export class LorenAdminChannelsService extends LorenBaseCrudService<LorenAdminChannel> {
    private currentChannelSource = new BehaviorSubject<number | null>(
        Number(sessionStorage.getItem(LorenSession.currentChannelKey))
    );
    public currentChannelUpdated$ = this.currentChannelSource.asObservable();

    constructor() {
        const endpoints = inject(LorenAdminChannelsEndpointsService);

        super(endpoints.channels());
    }

    private static setUserSessionChannels(channels: LorenAdminChannel[]) {
        sessionStorage.setItem(LorenSession.channelsKey, JSON.stringify(channels));
    }

    getCurrentChannel(): number {
        return this.currentChannelSource.value;
    }

    setCurrentChannel(channelId: number) {
        sessionStorage.setItem(
            LorenSession.currentChannelKey,
            channelId.toString()
        );
        this.currentChannelSource.next(channelId);
    }

    getChannels(): Observable<LorenAdminChannel[]> {
        return this.query().pipe(
            map((x: GenericItems<LorenAdminChannel>) => {
                const activeChannels = x.items.filter((c) => c.active);
                LorenAdminChannelsService.setUserSessionChannels(activeChannels);

                if (activeChannels.length > 0 && !this.getCurrentChannel()) {
                    this.setCurrentChannel(activeChannels[0].id);
                }
                return activeChannels;
            })
        );
    }
}
